"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const templateElement = document.getElementById('footer-blog-posts');
const allPostList = document.getElementById('footer-blog-list');
const loadingSpinner = document.getElementById('loading-spinner');
function getAllPosts() {
    return __awaiter(this, void 0, void 0, function* () {
        let posts = [];
        if (!allPostList) {
            console.warn('Container for displaying posts not found.');
            return;
        }
        if (!templateElement) {
            console.warn('Template to display posts not found.');
            return;
        }
        showSpinner();
        try {
            const { data } = yield axios_1.default.get('/ext/blog-articles');
            if (data.success && Array.isArray(data.articles)) {
                posts = data.articles.slice(0, 2);
            }
        }
        catch (error) {
            console.error('There was an error retrieving the blog posts, using default values.', error);
            posts = [
                {
                    title: "How Audiosales Orchestrated 148% Sales Growth with Marketing Automation",
                    image: "/assets/audiosales.png",
                    imageAlt: "post 1 img",
                    date: "February 11, 2025",
                    url: "/blog/how-audiosales-orchestrated-148-sales-growth-with-marketing-automation"
                },
                {
                    title: "#Growth Hack Series: Unlock Hidden Revenue with AI-powered Transactional Segmentation",
                    image: "/assets/images/blog/1200x627-(8).png",
                    imageAlt: "post 2 img",
                    date: "February 11, 2025",
                    url: "/blog/growth-hack-series-unlock-hidden-revenue-with-ai-powered-transactional-segmentation"
                }
            ];
        }
        hideSpinner();
        allPostList.innerHTML = '';
        posts.forEach(post => displayPost(post));
    });
}
const displayPost = (post) => {
    var _a, _b;
    if (!allPostList)
        return;
    const listItem = document.createElement('li');
    listItem.classList.add('footer-blog__entry');
    listItem.innerHTML = `
        <div class="footer-blog__img">
            <img src="${post.image}" alt="${(_a = post.imageAlt) !== null && _a !== void 0 ? _a : post.title}" class="img-responsive">
        </div>
        <div class="footer-blog__details">
            <div class="footer-blog__title">
                <a href="${(_b = post.url) !== null && _b !== void 0 ? _b : '#'}" target="_blank">${post.title}</a>
            </div>
            <div class="footer-blog__date">
                <span>${post.date}</span>
            </div>
        </div>
    `;
    allPostList.appendChild(listItem);
};
const showSpinner = () => {
    if (loadingSpinner) {
        loadingSpinner.style.display = 'block';
    }
};
const hideSpinner = () => {
    if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
    }
};
getAllPosts();
